import { CHANNEL_PKG_STATUS_NAME } from '../constants'
export const formatChannelPkgList = (data = []) => {
    const res = data
        .slice(0)
        .map(items => {
            return (items.current || []).concat(items.audit || [])
        })
        .flatMap(items => {
            // 这里的每一个 items 都是一个数组，其中包含了 32， 64 位包，最多会有3个
            if (items.length > 1) {
                items.forEach((item, index) => {
                    // 需要把这个数组里的多行数据归并为一行展示，样式上就是把两行中间的 border 设置为 none。这里需要标记一下除最后一行外，前面的行都需要设置 border-bottom: none
                    if (index < items.length - 1) {
                        item.borderBottomNone = true
                    }
                })
            }

            items.forEach(item => {
                item.originStatus = item.status
                item.status = CHANNEL_PKG_STATUS_NAME[item.status] || item.status
            })
            return items
        })
    return res
}
